fragment CoreEntryFields on EntryInterface {
    __typename
    id
    title
    uri
}
